module.exports = __webpack_public_path__ + "static/media/events-empty.59b4bb48.svg";